<template>
  <button
    :type="type"
    :disabled="disabled"
    class="star-button font-bold"
    @click="handleClick"
  >
    <span>{{ text }}</span>
    <div v-if="!disabled" class="star-1">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        viewBox="0 0 784.11 815.53"
      >
        <path
          class="fil0"
          d="M392.05 0c-20.9,210.08 -184.06,378.41 -392.05,407.78 207.96,29.37 371.12,197.68 392.05,407.74 20.93,-210.06 184.09,-378.37 392.05,-407.74 -207.98,-29.38 -371.16,-197.69 -392.06,-407.78z"
        />
      </svg>
    </div>
    <div v-if="!disabled" class="star-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        viewBox="0 0 784.11 815.53"
      >
        <path
          class="fil0"
          d="M392.05 0c-20.9,210.08 -184.06,378.41 -392.05,407.78 207.96,29.37 371.12,197.68 392.05,407.74 20.93,-210.06 184.09,-378.37 392.05,-407.74 -207.98,-29.38 -371.16,-197.69 -392.06,-407.78z"
        />
      </svg>
    </div>
    <div v-if="!disabled" class="star-3">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        viewBox="0 0 784.11 815.53"
      >
        <path
          class="fil0"
          d="M392.05 0c-20.9,210.08 -184.06,378.41 -392.05,407.78 207.96,29.37 371.12,197.68 392.05,407.74 20.93,-210.06 184.09,-378.37 392.05,-407.74 -207.98,-29.38 -371.16,-197.69 -392.06,-407.78z"
        />
      </svg>
    </div>
    <div v-if="!disabled" class="star-4">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        viewBox="0 0 784.11 815.53"
      >
        <path
          class="fil0"
          d="M392.05 0c-20.9,210.08 -184.06,378.41 -392.05,407.78 207.96,29.37 371.12,197.68 392.05,407.74 20.93,-210.06 184.09,-378.37 392.05,-407.74 -207.98,-29.38 -371.16,-197.69 -392.06,-407.78z"
        />
      </svg>
    </div>
    <div v-if="!disabled" class="star-5">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        viewBox="0 0 784.11 815.53"
      >
        <path
          class="fil0"
          d="M392.05 0c-20.9,210.08 -184.06,378.41 -392.05,407.78 207.96,29.37 371.12,197.68 392.05,407.74 20.93,-210.06 184.09,-378.37 392.05,-407.74 -207.98,-29.38 -371.16,-197.69 -392.06,-407.78z"
        />
      </svg>
    </div>
    <div v-if="!disabled" class="star-6">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        viewBox="0 0 784.11 815.53"
      >
        <path
          class="fil0"
          d="M392.05 0c-20.9,210.08 -184.06,378.41 -392.05,407.78 207.96,29.37 371.12,197.68 392.05,407.74 20.93,-210.06 184.09,-378.37 392.05,-407.74 -207.98,-29.38 -371.16,-197.69 -392.06,-407.78z"
        />
      </svg>
    </div>
  </button>
</template>

<script>
export default {
  name: 'StarButton',
  props: {
    text: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick(event) {
      if (!this.disabled) {
        this.$emit('click', event);
      }
    },
  },
};
</script>

<style scoped>
.star-button {
  position: relative;
  padding: 1rem 2.5rem;
  background: #58a8e1;
  color: white;
  border: 2px solid #58a8e1;
  border-radius: 200px;
  font-size: 1.125rem;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  overflow: visible;
  pointer-events: auto;
  z-index: 10;
}

.star-button span {
  position: relative;
  z-index: 20;
  pointer-events: none;
}

.star-button .fil0 {
  fill: white;
}

.star-button .star-1 {
  position: absolute;
  top: 20%;
  left: 20%;
  width: 25px;
  height: auto;
  filter: drop-shadow(0 0 0 #fff);
  opacity: 0;
  z-index: -5;
  transition: all 1s cubic-bezier(0.05, 0.83, 0.43, 0.96);
  pointer-events: none;
}

.star-button .star-2 {
  position: absolute;
  top: 45%;
  left: 45%;
  width: 15px;
  height: auto;
  filter: drop-shadow(0 0 0 #fff);
  opacity: 0;
  z-index: -5;
  transition: all 1s cubic-bezier(0, 0.4, 0, 1.01);
  pointer-events: none;
}

.star-button .star-3 {
  position: absolute;
  top: 40%;
  left: 40%;
  width: 5px;
  height: auto;
  filter: drop-shadow(0 0 0 #fff);
  opacity: 0;
  z-index: -5;
  transition: all 1s cubic-bezier(0, 0.4, 0, 1.01);
  pointer-events: none;
}

.star-button .star-4 {
  position: absolute;
  top: 20%;
  left: 40%;
  width: 8px;
  height: auto;
  filter: drop-shadow(0 0 0 #fff);
  opacity: 0;
  z-index: -5;
  transition: all 0.8s cubic-bezier(0, 0.4, 0, 1.01);
  pointer-events: none;
}

.star-button .star-5 {
  position: absolute;
  top: 25%;
  left: 45%;
  width: 15px;
  height: auto;
  filter: drop-shadow(0 0 0 #fff);
  opacity: 0;
  z-index: -5;
  transition: all 0.6s cubic-bezier(0, 0.4, 0, 1.01);
  pointer-events: none;
}

.star-button .star-6 {
  position: absolute;
  top: 5%;
  left: 50%;
  width: 5px;
  height: auto;
  filter: drop-shadow(0 0 0 #fff);
  opacity: 0;
  z-index: -5;
  transition: all 0.8s ease;
  pointer-events: none;
}

.star-button:hover:not(:disabled) {
  background: transparent;
  border: 2px solid #a5c8e1;
  box-shadow: 0 0 10px #a5c8e1;
}

.star-button:hover:not(:disabled) .fil0 {
  fill: white;
}

.star-button:hover:not(:disabled) .star-1 {
  position: absolute;
  top: -80%;
  left: -30%;
  width: 25px;
  height: auto;
  filter: drop-shadow(0 0 0px #fff);
  opacity: 1;
  z-index: 2;
}

.star-button:hover:not(:disabled) .star-2 {
  position: absolute;
  top: -25%;
  left: 10%;
  width: 15px;
  height: auto;
  filter: drop-shadow(0 0 0px #fff);
  opacity: 1;
  z-index: 2;
}

.star-button:hover:not(:disabled) .star-3 {
  position: absolute;
  top: 55%;
  left: 25%;
  width: 5px;
  height: auto;
  filter: drop-shadow(0 0 0px #fff);
  opacity: 1;
  z-index: 2;
}

.star-button:hover:not(:disabled) .star-4 {
  position: absolute;
  top: 30%;
  left: 80%;
  width: 8px;
  height: auto;
  filter: drop-shadow(0 0 0px #fff);
  opacity: 1;
  z-index: 2;
}

.star-button:hover:not(:disabled) .star-5 {
  position: absolute;
  top: 25%;
  left: 115%;
  width: 15px;
  height: auto;
  filter: drop-shadow(0 0 0px #fff);
  opacity: 1;
  z-index: 2;
}

.star-button:hover:not(:disabled) .star-6 {
  position: absolute;
  top: 5%;
  left: 60%;
  width: 5px;
  height: auto;
  filter: drop-shadow(0 0 0px #fff);
  opacity: 1;
  z-index: 2;
}

.star-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
